import { Card, Stack, TextField } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import { useGetApp } from "./hook/useGetApp";
import SectionTitle from "./SectionTitle";

// ----------------------------------------------------------------------

export const DisplayNameAppCard = () => {
	const app = useGetApp();
	const { translate } = useLocales();

	return (
		<Card sx={{ maxWidth: 800, p: 3 }}>
			<SectionTitle
				title={translate("app_settings.public_name")}
				description={translate("app_settings.public_name_description")}
			/>
			<Stack sx={{ mt: 3 }} flexDirection={"row"} alignItems='center' gap={3}>
				<TextField
					label={translate("app_settings.public_name")}
					value={app?.displayName}
					disabled
					sx={{ width: { xs: "auto", sm: 300 } }}
				/>
			</Stack>
		</Card>
	);
};

export default DisplayNameAppCard;
